import React from "react"
import { Navigate } from "react-router-dom"

import Organization from "../pages/organization"
import CardInfo from '../pages/card_info'
import CardCharge from "../pages/card_charge"
import CardOrder from "../pages/card_order"
import Report from '../pages/report'
import GasStations from "../pages/gas_stations"
import Help from "../pages/help"
import Contact from "../pages/contact"


const authProtectedRoutes = [
  { path: "/organization", component: Organization },
  { path: "/card_info", component: CardInfo },
  { path: "/card_charge", component: CardCharge },
  { path: "/card_order", component: CardOrder },
  { path: "/report", component: Report },
  { path: "/gstation", component: GasStations },

  { path: "/help", component: Help },
  { path: "/contact", component: Contact },

  { path: "/", exact: true, component: () => <Navigate to="/organization" /> },
]

const publicRoutes = [
    
]

export { publicRoutes, authProtectedRoutes }
